import React from 'react';
import { Box, Skeleton } from '@mui/material';

const WhyIndiaSkeleton = () => (
  <Box className="hero-section">
    <Box className="hero-text">
      <Skeleton variant="text" width={200} height={60} />
      <Skeleton variant="text" width={300} height={40} />
      <Skeleton variant="rectangular" width="100%" height={300} />
    </Box>
    <Skeleton variant="rectangular" width="100%" height={400} />
  </Box>
);

export default WhyIndiaSkeleton;
